import { render, staticRenderFns } from "./PersonnalMess.vue?vue&type=template&id=c42c34e6&"
import script from "./PersonnalMess.vue?vue&type=script&lang=js&"
export * from "./PersonnalMess.vue?vue&type=script&lang=js&"
import style0 from "./PersonnalMess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports